module.exports = __webpack_public_path__ + "img/offer-ico_3.52fc61d3.png";